module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NewsHeader"
  }, [_c('div', {
    staticClass: "NewsHeader-content"
  }, [_c('title-location', {
    staticClass: "NewsHeader-titleLocation",
    attrs: {
      "title": "News",
      "title-route": {
        name: 'news'
      },
      "location": _vm.location,
      "inline": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NewsHeader-search"
  }, [_c('news-search')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36fe7b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsHeader.vue
// module id = 756
// module chunks = 1474